module.exports = "/images/Homepage-Missing Brick.jpg";